/**
 * @file useLayer
 * @author yuzong(yuzong@tencent.com)
 */
import { useRef } from 'react';
import { useLayerInstance } from '../context/layer';
export function useLayer() {
  var instance = useLayerInstance();
  var ref = useRef(document.body);
  ref.current = instance || document.body;
  return ref;
}